module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "logo-4.8faf2f31.svg";